module.exports = __webpack_public_path__ + "static/media/lessons.b422aba2.svg";